export default {
    loading() {
        return this.$store.state.loading
    },

    acceptedCookies() {
        return this.$store.state.acceptedCookies
    },

    isImpersonating() {
        return this.$store.state.impersonationData.email && this.$store.state.impersonationData.token
    },

    impersonatedUser() {
        return this.$store.state.impersonationData.email
    }
}
